import ApiCore from './ApiCore';
import {queryParams, getIsoDate, changeDate} from '../helpers';

class CustomizationfeesService extends ApiCore {

	adminList(params = null, previousResponse = [], nextPage = null) {
    // console.log("admin");
    return new Promise((resolve, reject) => {
      let updatedParams = {...params};
      if(nextPage){
        updatedParams.page = nextPage;
      }
      // console.log('backoffice/admin/projects'+queryParams(updatedParams));
      this.instance.get('backoffice/admin/customizationFees'+queryParams(updatedParams)).then(response => {
        // console.log(response.data.nextPage);
        if(response.data.nextPage){
          this.adminList(params, previousResponse.concat(response.data.result), response.data.nextPage).then(response2 => {
            resolve(response2);
          });
        }else{
          resolve(previousResponse.concat(response.data.result));
        }        
      }).catch(error => {
        reject(error);
      });
    });
  }

  adminCreate(params = null, userUuid) {
    return new Promise((resolve, reject) => {
      let updatedParams = {...params};
      updatedParams.day = getIsoDate(new Date(changeDate(params.day,1,"days"))).split("T")[0];

			
      this.instance.post('backoffice/admin/customizationFees?userUuid='+userUuid, {
        ...updatedParams
      }).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }

  adminDelete(uuid) {
    return new Promise((resolve, reject) => {
      this.instance.delete('backoffice/admin/customizationFees/'+uuid).then(response => {
        resolve(response.data);
      }).catch(error => {
        reject(error);
      });
    });
  }
  
}
let service =  new CustomizationfeesService();
export default service;
